export function normalizeColorKey(key: string) {
  return key.replace('.', '_').toUpperCase();
}
